@if (((items && items.length > 0) || banners) && (size$ | async); as size) {
    <div class="row align-items-center">
        <div class="col-12">
            <div class="d-flex align-items-center">
                @if (title) {
                    <h3 class="d-inline-block mr-3">{{ title }}</h3>
                }
                <div class="d-flex align-items-center justify-content-end ml-auto">
                    @if (showAllUrl && showScroll()) {
                        <a
                            class="show-all"
                            [ngClass]="{
                                'no-title': !title,
                                'd-inline-block d-sm-none': showAllText,
                            }"
                            [routerLink]="showAllUrl"
                            [queryParams]="getInternalQueryParams()"
                            >{{ 'aimo.product.carousel.showAll' | cxTranslate }}</a
                        >
                        @if (showAllUrl) {
                            <a
                                class="show-all d-none d-sm-inline-block"
                                [ngClass]="{
                                    'no-title': !title,
                                }"
                                [routerLink]="showAllUrl"
                                [queryParams]="getInternalQueryParams()"
                                >{{ showAllText }}</a
                            >
                        }
                    }
                    @if (showAsAccordion) {
                        <button class="btn btn-sm btn-icon btn-icon-transparent ml-3" (click)="toggleAccordion()">
                            <i
                                class="aimo-icon icon-lg icon-petrol-blue"
                                [ngClass]="{
                                    'icon-caret-down': !accordionOpen,
                                    'icon-caret-up': accordionOpen,
                                }"></i>
                        </button>
                    }
                </div>
            </div>
        </div>
    </div>
    @if (accordionOpen) {
        <div class="carousel-wrapper">
            <div
                class="carousel-panel"
                (scroll)="scroll(divContainer)"
                [ngClass]="{
                    'show-scroll': showScroll(),
                    'no-title': !title && !(showAllUrl && showScroll()),
                }"
                #divContainer>
                @if (showButton(divContainer, true, divSlides)) {
                    <div class="carousel-fade">
                        <div class="fade-left"></div>
                    </div>
                }
                @if (showButton(divContainer, true, divSlides)) {
                    <button
                        class="previous btn btn-primary btn-icon btn-lg"
                        (click)="scrollContainer(divContainer, true)"
                        [attr.aria-label]="'aimo.product.carousel.previousSlide' | cxTranslate">
                        <i class="aimo-icon icon-caret-left icon-sm icon-white"></i>
                    </button>
                }
                <div class="slides" #divSlides data-title="{{ title }}">
                    @for (_ of banners; track _; let i = $index) {
                        @if (i % size === 0) {
                            <div class="slide" [class.active]="i === activeSlide">
                                @for (item of banners | slice: i : i + size; track item; let j = $index) {
                                    @if (item; as data) {
                                        <div
                                            [id]="'slide_' + item.uid + '_' + idSuffix"
                                            [attr.data-slide]="i"
                                            class="item"
                                            [class.active]="i === activeSlide">
                                            <ng-container
                                                *ngTemplateOutlet="
                                                    template;
                                                    context: { item: data, index: j }
                                                "></ng-container>
                                        </div>
                                    }
                                }
                            </div>
                        }
                    }
                    @for (_ of items; track _; let i = $index) {
                        @if (i % size === 0) {
                            <div class="slide" [class.active]="i === activeSlide">
                                @if (banner$ | async; as banner) {
                                    <ng-container
                                        *ngTemplateOutlet="
                                            carouselWithBanner;
                                            context: { banner: banner }
                                        "></ng-container>
                                } @else {
                                    @for (item of items | slice: i : i + size; track item; let j = $index) {
                                        @if (item | async; as data) {
                                            <div
                                                [id]="'slide_' + data.code + '_' + idSuffix"
                                                [attr.data-slide]="i"
                                                class="item"
                                                [class.active]="i === activeSlide">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        template;
                                                        context: {
                                                            item: data,
                                                            index: j,
                                                            idSuffix: idSuffix,
                                                            gtmListId: gtmParams?.gtmItemListId,
                                                        }
                                                    "></ng-container>
                                            </div>
                                        }
                                    }
                                }
                                <ng-template #carouselWithBanner let-banner="banner">
                                    @if (banner.uid) {
                                        <aimo-banner
                                            [id]="'slide_' + banner.uid + '_' + idSuffix"
                                            [banner]="banner"
                                            [attr.data-slide]="i"
                                            class="item"
                                            [class.active]="i === activeSlide"></aimo-banner>
                                    }
                                    <ng-container *ngTemplateOutlet="carouselProducts"></ng-container>
                                </ng-template>
                                <ng-template #carouselProducts>
                                    @for (item of items | slice: i : i + size; track item; let j = $index) {
                                        @if (item | async; as data) {
                                            <div
                                                [id]="'slide_' + data.code + '_' + idSuffix"
                                                [attr.data-slide]="i"
                                                class="item"
                                                [class.active]="i === activeSlide">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        template;
                                                        context: {
                                                            item: data,
                                                            index: j,
                                                            idSuffix: idSuffix,
                                                            gtmListId: gtmParams?.gtmItemListId,
                                                        }
                                                    "></ng-container>
                                            </div>
                                        }
                                    }
                                </ng-template>
                                @if (showAllUrl && showScroll()) {
                                    <div class="item active">
                                        <div class="show-more">
                                            <a
                                                class="btn btn-primary"
                                                [routerLink]="showAllUrl"
                                                [queryParams]="getInternalQueryParams()"
                                                >{{ 'aimo.product.carousel.showAll' | cxTranslate }}</a
                                            >
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
                @if (showButton(divContainer, false, divSlides)) {
                    <div class="carousel-fade">
                        <div class="fade-right"></div>
                    </div>
                }
                @if (showButton(divContainer, false, divSlides)) {
                    <button
                        class="next btn-primary btn-icon btn-lg"
                        (click)="scrollContainer(divContainer, false)"
                        tabindex="-1"
                        [attr.aria-label]="'aimo.product.carousel.nextSlide' | cxTranslate">
                        <i class="aimo-icon icon-caret-right icon-sm icon-white"></i>
                    </button>
                }
            </div>
        </div>
    }
    @if (!hideIndicators && size < items.length) {
        <div class="indicators">
            @for (_ of items; track _; let i = $index) {
                @if (i % size === 0) {
                    <button
                        (focus)="activeSlide = i"
                        [disabled]="i === activeSlide"
                        [attr.aria-label]="
                            'carousel.slideNumber' | cxTranslate: { currentSlideNumber: getSlideNumber(size, i) }
                        "
                        tabindex="-1">
                        <cx-icon [type]="indicatorIcon" aria-hidden="true"></cx-icon>
                    </button>
                }
            }
        </div>
    }
}
